import Stack from "@mui/material/Stack";
import * as React from "react";
import Container from "@mui/material/Container";

const faqData = [
  {
    id: "panel1",
    question: "How can I contact you if any questions or issues?",
    answer: "You can reach our customer support team by emailing support@app20.co or calling our toll-free number. We're here to assist you promptly.",
  },
  {
    id: "panel2",
    question: "How do I upload the screenshots",
    answer: "Just follow the directions on the homepage after you log in. Once you install the app, you will be redirected to the page where you can upload the screenshots.",
  },
  {
    id: "panel3",
    question: "How long will it take to receive the payment?",
    answer: "Our dedicated team reviews the submitted screenshots and processes the payments as soon as they are verified. You can expect a maximum delay ranging from a few minutes to a few hours.",
  },
  {
    id: "panel4",
    question: "Where can I receive the payment?",
    answer: "You can receive the payment through PayPal. Enter the PayPal ID of your choice after completing the steps given on the homepage.",
  },
];

export default function FAQ() {
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange = (panel: string) => {
    setExpanded((prev) => (prev === panel ? false : panel));
  };

  return (
    <Container
      id="faq"
      sx={{
        pt: 4,
        pb: 4,
      }}
    >
      <div className="max-w-2xl mx-auto">
        {/* FAQ Heading */}
        <div className="text-center mb-8">
          <p className="text-[#FFB300] font-bold tracking-wider text-xs uppercase mb-2">
            FREQUENTLY ASKED QUESTIONS
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight">
            All your doubt <br className="hidden md:block" />
            resolved
          </h2>
        </div>

        <Stack spacing={3}>
          {faqData.map(({ id, question, answer }) => {
            const isOpen = expanded === id;

            return (
              <div
                key={id}
                className={`border rounded-2xl bg-white transition-all duration-300 overflow-hidden ${isOpen ? "border-white shadow-lg" : "border-white shadow-sm"
                  }`}
              // Added bg-white to ensure cards stand out on yellow bg
              >
                <button
                  onClick={() => handleChange(id)}
                  className="w-full flex items-center justify-between p-5 text-left bg-white focus:outline-none group"
                >
                  <span className="text-lg text-gray-900 font-medium pr-4">
                    {question}
                  </span>
                  <div className="flex-shrink-0">
                    {isOpen ? (
                      <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-blue-600 border-2 border-blue-600 text-white transition-colors">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 1L13 13M1 13L13 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </div>
                    ) : (
                      <div className="w-8 h-8 flex items-center justify-center rounded-lg border-2 border-blue-500 text-blue-500 bg-white group-hover:bg-blue-50 transition-colors">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7 1V13M1 7H13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </div>
                    )}
                  </div>
                </button>

                <div
                  className={`transition-all duration-300 ease-in-out bg-white ${isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                    }`}
                >
                  <div className="px-5 pb-5 text-gray-600 leading-relaxed font-light text-[15px]">
                    {answer}
                  </div>
                </div>
              </div>
            );
          })}
        </Stack>
      </div>
    </Container>
  );
}
